import { CardTemplate, DefaultTemplate } from '@bingads-webui-fluent-component/wizard';
import { LINKEDIN_WIZARD_STEP_PATHS } from '@bingads-webui-campaign-react/linkedin-utils';

import { ProcessingBlocker } from './processing-blocker';

export const layoutConfig = {
  [LINKEDIN_WIZARD_STEP_PATHS.LI_COMPANY_PAGE_LINKING]: {
    template: CardTemplate,
    customBlocker: ProcessingBlocker,
    // Will enable this in the future for better development experience
    // noFooter: true,
  },
  [LINKEDIN_WIZARD_STEP_PATHS.LINKEDIN_AD]: {
    template: DefaultTemplate,
  },
  [LINKEDIN_WIZARD_STEP_PATHS.MULTI_AD_MANAGER]: {
    template: DefaultTemplate,
  },
  [LINKEDIN_WIZARD_STEP_PATHS.TARGETING]: {
    template: DefaultTemplate,
  },
  [LINKEDIN_WIZARD_STEP_PATHS.BUDGET]: {
    template: DefaultTemplate,
  },
  [LINKEDIN_WIZARD_STEP_PATHS.SUMMARY]: {
    template: DefaultTemplate,
  },
};
